import React from 'react';
import CanonicalDatasetDefault from '../protocolRegistration/CanonicalDataset';

// Handle both default- and named-export shapes for CanonicalDataset.
const CanonicalDataset = CanonicalDatasetDefault?.default || CanonicalDatasetDefault;

const CoreDatasheet = ({ projectId }) => {
  // Additional safety check
  if (!CanonicalDataset || typeof CanonicalDataset !== 'function') {
    console.error('❌ Cannot render CanonicalDataset - it is not a valid component');
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h3>Error: CanonicalDataset component is not available</h3>
        <p>Type: {typeof CanonicalDataset}</p>
        <p>Value: {String(CanonicalDataset)}</p>
      </div>
    );
  }
  
  return <CanonicalDataset projectId={projectId} />;
};

export default CoreDatasheet;

